<template>
    <b-row class="flex-row-reverse" no-gutters>
        <b-spinner small v-if="isLoading" class="float-right mx-3"></b-spinner>
        <span v-else class="float-right font-weight-bold mx-3">Situação: {{ situacao }}</span>
    </b-row>
</template>
<script lang="ts">
import { UtilsTS } from '@/utilsts';
import { eventBus } from '@/main';
import { mixins } from 'vue-class-component';
import { Component, Vue, Watch } from 'vue-property-decorator';
import contratoService from '@/services/licitacoes/contratoService'

const CompProps = Vue.extend({
    name: 'SituacaoContrato',
    props: {
        idContrato: {
            type: Number,
        }
    }
})
@Component
export default class SituacaoContrato extends mixins(UtilsTS, CompProps) {
    isLoading = true
    situacao = ''

    created() {
        this.recarregar()
        eventBus.$on('atualizar-status-contrato', this.recarregar)
    }
    destroyed() {
        eventBus.$off('atualizar-status-contrato', this.recarregar)
    }
    @Watch('idContrato')
    atualizar(newv) {
        if (newv > 0) this.recarregar()
    }

    async recarregar(novaSituacao: string | null = null) {
        try {
            if (!this.idContrato) return this.situacao = 'Não cadastrado'
            if (novaSituacao) return this.tratarRetorno(novaSituacao)
            this.isLoading = true
            this.tratarRetorno(await contratoService.buscarSituacao(this.idContrato))
        } catch (e: any) {
            console.error('Falha ao obter a situação do contrato', e)
            this.situacao = ''
        } finally {
            this.isLoading = false
        }
    }

    //TODO: Centralizar isto. É usado aqui, em licitacao-resumida.ts e em licitacao.ts
    tratarRetorno(retorno: string): void {
        switch (retorno) {
            case "EM":
                this.situacao = "Em Cadastramento";
                break;
            case "FI":
                this.situacao = "Cadastrado";
                break;
            case "AN":
                this.situacao = "Anulado";
                break;
            default:
                this.situacao = '';
                break;
        }
    }
}
</script>